/* eslint-disable @typescript-eslint/no-unused-vars */
import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Grid, TextField, Typography } from '@mui/material';

import { Loadin } from '../../../shared';
import { useEffect, useState } from 'react';
import { RISR, ReportsServicesRisr } from '../../../../services/api/reports/ReportsServicesRisr';
import { formatDateWhitoutHour } from '../../../../services/helpers/helpers';

interface ICardRisr {
    data: RISR; 
}

export const CardRisr = ({ data }: ICardRisr) => {
    const uuid = data.uuid;
    const [risr, setRisr] = useState<RISR | undefined>(undefined);

    useEffect(() => {
        fetchData();
    }, [uuid]); 

    const fetchData = () => {
        if (uuid) {
            ReportsServicesRisr.get(uuid)
                .then((result) => {
                    if (result instanceof Error) {
                        console.log(result.message);
                        setRisr(undefined);
                    } else {
                        setRisr(result);
                    }
                })
                .catch((error) => {
                    setRisr(undefined);
                });
        } else {
            setRisr(undefined); 
        }
    };

    if (risr === undefined) {
        return (
            <Box>
                <Loadin />
            </Box>
        );
    }

    return (
        <Box width={'100%'} gap={2} display={'flex'} flexDirection={'column'} padding={1}>
            <Accordion variant='outlined' square={true} sx={{ borderRadius: '30px', '&:before': { display: 'none', } }} disableGutters>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant='subtitle1'>Geral</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid>
                        <Grid container alignContent={'center'} spacing={2} gap={2}>
                            <Grid container gap={2} padding={1}>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={formatDateWhitoutHour(risr.periodo_referencia) || ''}
                                            label='Período de referencia'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={risr.empresa_executora || ''}
                                            label='Empresa executora'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={formatDateWhitoutHour(risr.data_inspecao) || ''}
                                            label='Data de inspeção'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={formatDateWhitoutHour(risr.data_dce) || ''}
                                            label='Data de DCE'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={risr.status_dce || ''}
                                            label='Status do protocolo (DCE/EISR)'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={risr.responsavel || ''}
                                            label='Responsável técnico'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={risr.art || ''} 
                                            label='ART (número)'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={risr.orgao || ''}
                                            label='Órgão fiscalizador'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={risr.dpa || ''}
                                            label='Dano Potencial Associado (DPA)'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={risr.cri || ''}
                                            label='Categoria de Risco (CRI)'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={risr.classificacao || ''}
                                            label='Classificação (conforme órgão fiscalizador)'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={risr.npgb || ''}
                                            label='Nível de Perigo Global da Barragem (NPGB)'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>

            {risr.verificacaoHidrologica ? ( 
                <Accordion variant='outlined' square={true} sx={{ borderRadius: '30px', '&:before': { display: 'none', } }} disableGutters>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography variant='subtitle1'>Verificação Hidrológica/Hidráulica</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid >
                            <Grid container alignContent={'center'} spacing={2} gap={2}>
                                <Grid container gap={2} padding={1}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <TextField
                                                InputLabelProps={{ shrink: true }}
                                                value={risr.verificacaoHidrologica.area_drenagem || ''}
                                                label='Área de drenagem'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                InputLabelProps={{ shrink: true }}
                                                value={risr.verificacaoHidrologica.bombeamento || ''}
                                                label='Bombeamento'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                InputLabelProps={{ shrink: true }}
                                                value={risr.verificacaoHidrologica.borda_livre || ''}
                                                label='Borda livre'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                InputLabelProps={{ shrink: true }}
                                                value={risr.verificacaoHidrologica.duracao_chuva || ''}
                                                label='Duração da chuva'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                InputLabelProps={{ shrink: true }}
                                                value={risr.verificacaoHidrologica.na_maximo_maximorum || ''}
                                                label='NA máximo'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                InputLabelProps={{ shrink: true }}
                                                value={risr.verificacaoHidrologica.na_maximo_operacional || ''}
                                                label='NA máximo operacional'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                InputLabelProps={{ shrink: true }}
                                                value={risr.verificacaoHidrologica.precipitacao_pmp || ''}
                                                label='Precipitação PMP'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                InputLabelProps={{ shrink: true }}
                                                value={risr.verificacaoHidrologica.precipitacao_projeto || ''}
                                                label='Precipitação do projeto'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                InputLabelProps={{ shrink: true }}
                                                value={risr.verificacaoHidrologica.vazao_maxima || ''}
                                                label='Vazão máxima'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Divider />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            ) : null}

            {risr.monitoramentos && risr.monitoramentos.length > 0 ? ( 
                <Accordion variant='outlined' square={true} sx={{ borderRadius: '30px', '&:before': { display: 'none', } }} disableGutters>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography variant='subtitle1'>Interpretação dos Monitoramentos</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid >
                            {risr.monitoramentos.map((item, index) => (
                                <Grid container alignContent={'center'} spacing={2} gap={2} key={index}>
                                    <Grid container gap={2} padding={1}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={item.destaque || ''}
                                                    label='Destaque'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={item.tipo || ''}
                                                    label='Tipo'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Divider />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            ) : null}

            {risr.recomendacoes && risr.recomendacoes.length > 0 ? ( 
                <Accordion variant='outlined' square={true} sx={{ borderRadius: '30px', '&:before': { display: 'none', } }} disableGutters>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography variant='subtitle1'>Recomendações</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid >
                            {risr.recomendacoes.map((item, index) => (
                                <Grid container alignContent={'center'} spacing={2} gap={2} key={index}>
                                    <Grid container gap={2} padding={1}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={item.recomendacao || ''}
                                                    label='Recomendação'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={formatDateWhitoutHour(item.prazo) || ''}
                                                    label='Prazo'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Divider />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            ) : null}
        </Box>
    );
};